import { render, staticRenderFns } from "./LastCongelation.vue?vue&type=template&id=248e6fc6&"
import script from "./LastCongelation.vue?vue&type=script&lang=js&"
export * from "./LastCongelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports